<template>
  <div>
    <BaseLink
      :class="$style.base"
      data-pw="resend-verification"
      @click="clickDLPush('zu-versendende-nachricht-ansehen', 'click'),
              toggleModal(true)
      "
    >
      Nachricht ansehen
    </BaseLink>
    <BaseModal
      :active="modalIsOpen"
      button-label="In Ordnung, weiter"
      @closed="clickDLPush('zu-versendende-nachricht-schliessen', 'click'),
               toggleModal(false)
      "
    >
      <template #content>
        <span v-if="isContactSms">
          <ModalContactSmsContent />
        </span>
        <span v-else-if="!isContactSms">
          <ModalContactMailContent />
        </span>
      </template>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { isEmpty } from 'lodash-es'
import type { Appointment } from '~/terminierungsportal/types/appointmentTypes'
import ModalContactSmsContent from '~/terminierungsportal/components/modals/ModalContactSmsContent.vue'
import ModalContactMailContent from '~/terminierungsportal/components/modals/ModalContactMailContent.vue'
import BaseModal from '~/base/components/modal/Modal.vue'
import { useDataLayerMixin } from '~/base/composables/useDataLayer'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import BaseLink from '~/base/components/link/Link.vue'

const appointmentStore = useAppointmentStore()
const modalOpen = ref(false)

const appointment = computed((): Appointment => {
  return appointmentStore.appointment
})

const modalIsOpen = computed((): boolean => {
  return modalOpen.value
})

const toggleModal = (state: boolean): void => {
  modalOpen.value = state
}

const isContactSms = computed((): boolean => {
  return !isEmpty(appointment.value.alternativeContact.phone)
})

const { clickDLPush } = useDataLayerMixin()
</script>

<style module>
.base {
  display: block;
  margin-top: var(--space-xs);
  line-height: 17px;
  letter-spacing: 0.18px;
}
</style>
